import { styled, Stack } from '@nextiva/next-ui-components';

export const StyledGlobalHeader = styled('header', {
  shouldForwardProp: (prop) => prop !== 'hasLeftPadding',
})(({ theme, hasLeftPadding }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: theme.spacing(7),
  backgroundColor: 'white',
  borderBottom: `1px solid ${theme.palette.grey.A100}`,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  paddingLeft: hasLeftPadding ? theme.spacing(2) : undefined,
  paddingRight: theme.spacing(2),
  position: 'relative',
}));

export const StyledWaffleMenuContainer = styled('div')(({ theme }) => ({
  height: theme.spacing(7),
  width: theme.spacing(7),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledContentContainer = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  height: '100%',
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(2),
  '& > *:not(:last-child)': {
    marginRight: theme.spacing(2),
  },
}));

export const StyledStack = styled(Stack)({
  '& > *:not(:last-child)': {
    marginRight: 11,
  },
});

export const StyledLogo = styled('img')({
  height: '24px',
  marginBottom: '7px',
});
